import { Crown, Gem, Medal } from "lucide-react";
import { STATUS, ORDER_STATUS } from "@/lib/api";

const ICON = { bronze: Medal, gold: Crown, diamond: Gem };

export function StatusBadge({ status = "bronze", small }) {
  const s = STATUS[status] || STATUS.bronze;
  const Icon = ICON[status] || Medal;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1 rounded-full border font-semibold uppercase tracking-wider ${small ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs"}`}
      style={{ color: s.color, borderColor: `${s.color}66`, background: `${s.color}1a` }}
    >
      <Icon className={small ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {s.label}
    </span>
  );
}

export function StateBadge({ status, testid }) {
  const s = ORDER_STATUS[status] || { label: status, cls: "bg-white/10 text-slate-300 border-white/10" };
  return <span data-testid={testid} className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}>{s.label}</span>;
}

const AVAIL = {
  disponibile: ["Disponibile", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30", "InStock"],
  limitata: ["Disponibilità limitata", "bg-amber-500/15 text-amber-300 border-amber-500/30", "LimitedAvailability"],
  "in arrivo": ["In arrivo", "bg-sky-500/15 text-sky-300 border-sky-500/30", "PreOrder"],
  out: ["Non disponibile", "bg-red-500/15 text-red-300 border-red-500/30", "OutOfStock"],
};

export const availabilityOf = (offer) => {
  const a = (offer.availability || "").toLowerCase();
  if (a === "in arrivo") return AVAIL["in arrivo"];
  if (offer.stock <= 0 || a.startsWith("non")) return AVAIL.out;
  if (a === "limitata") return AVAIL.limitata;
  return AVAIL.disponibile;
};

export function AvailabilityBadge({ offer, testid }) {
  const [label, cls] = availabilityOf(offer);
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" /> {label}{offer.stock > 0 ? ` · ${offer.stock} pz` : ""}
    </span>
  );
}
